
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("dhbEh", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $4xcIM = parcelRequire("4xcIM");


var $inPa6 = parcelRequire("inPa6");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $7Ndnw = parcelRequire("7Ndnw");


var $7QUD1 = parcelRequire("7QUD1");


var $hIaUw = parcelRequire("hIaUw");


var $8a9Dm = parcelRequire("8a9Dm");


var $dizL5 = parcelRequire("dizL5");


var $bQm3c = parcelRequire("bQm3c");


var $ep3mz = parcelRequire("ep3mz");


var $6UqI3 = parcelRequire("6UqI3");


var $6uUjl = parcelRequire("6uUjl");


var $3IBnw = parcelRequire("3IBnw");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3jwuS = parcelRequire("3jwuS");


var $c54hr = parcelRequire("c54hr");














var $9hlns = parcelRequire("9hlns");


var $9fBoq = parcelRequire("9fBoq");


var $al4VD = parcelRequire("al4VD");

const $ced39bfea5ef5993$var$Container = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { isLoading: isLoading, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_kqswh2mm",
            __cmplp.isLoading ? "_syaz1rpy" : "_syazn7od",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $ced39bfea5ef5993$var$CenterSpinner = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_18u0x0bf _19pkx0bf _1e0c1txw _1bah1h6o _4cvr1h6o",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
function $ced39bfea5ef5993$export$9f275aff884e1431(t0) {
    const $ = (0, $frIzR.c)(16);
    const { extension: extension, onClick: onClick, isLoading: isLoading } = t0;
    let t1;
    if ($[0] !== extension || $[1] !== onClick) {
        t1 = (e)=>{
            e.stopPropagation();
            onClick(extension);
        };
        $[0] = extension;
        $[1] = onClick;
        $[2] = t1;
    } else t1 = $[2];
    const onClickCB = t1;
    const t2 = extension.id;
    let t3;
    if ($[3] !== extension) {
        t3 = (0, $9fBoq.extensionTitle)(extension);
        $[3] = extension;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== isLoading) {
        t4 = isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ced39bfea5ef5993$var$CenterSpinner, {
            "data-test-id": "forge-ui-extension-loading-spinner"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
            size: "small"
        }));
        $[5] = isLoading;
        $[6] = t4;
    } else t4 = $[6];
    let t5;
    if ($[7] !== isLoading || $[8] !== t3 || $[9] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ced39bfea5ef5993$var$Container, {
            isLoading: isLoading
        }, t3, t4);
        $[7] = isLoading;
        $[8] = t3;
        $[9] = t4;
        $[10] = t5;
    } else t5 = $[10];
    let t6;
    if ($[11] !== extension.id || $[12] !== isLoading || $[13] !== onClickCB || $[14] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $al4VD.ContentToolsItem), {
            id: t2,
            isDisabled: isLoading,
            label: t5,
            onClick: onClickCB
        });
        $[11] = extension.id;
        $[12] = isLoading;
        $[13] = onClickCB;
        $[14] = t5;
        $[15] = t6;
    } else t6 = $[15];
    return t6;
}
$ced39bfea5ef5993$export$9f275aff884e1431.propTypes = {
    extension: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object.isRequired,
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired,
    isLoading: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool.isRequired
};



var $9MrOn = parcelRequire("9MrOn");

const $0c33e41081c1500e$var$EXPERIENCE_NAME = (0, $irVI7.VIEW_PAGE_CONTENT_TOOLS_FORGE_EXPERIENCE);
function $0c33e41081c1500e$export$7cf22b806dbb23cb({ contentId: contentId, spaceKey: spaceKey, children: children, onLoadComplete: onLoadComplete, isDropdownMenuOpen: isDropdownMenuOpen, lazyLoaderPlaceholderComponent: lazyLoaderPlaceholderComponent = null }) {
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext)); // Forge menu items are behaving a little different than other menu items. They show a loading spinner if one of them
    // is clicked. There are a few different cases that needs to be handled while a forge extension is being loaded:
    // 1. Show a loading spinner while an extension id being loaded.
    //    - Stop showing the loading spinner once the extension is loaded.
    //    - Close the dropdown menu once the extension is loaded.
    // 2. If dropdown menu is closed while an extension is being loaded then stop loading the extension.
    // If there's a selected extension then `loadExtension` state changes like this:
    // +----------+----------------------+------------------+
    // |isLoading |   isDropdownMenuOpen |    loadExtension |
    // +----------------------------------------------------+
    // |          |                      |                  |
    // | false    |   false              |    true          |  --> keep showing the loaded extension
    // |          |                      |                  |
    // | false    |   true               |    true          |  --> keep showing the loaded extension
    // |          |                      |                  |
    // | true     |   false              |    false         |  --> stop loading the extension
    // |          |                      |                  |
    // | true     |   true               |    true          |  --> keep loading the extension
    // +----------+----------------------+------------------+
    const [extension, showExtension] = (0, $42omo.useState)(null);
    const [isLoading, setLoading] = (0, $42omo.useState)(false);
    const loadExtension = extension && !(isLoading && !isDropdownMenuOpen);
    (0, $42omo.useEffect)(()=>{
        if (!loadExtension) {
            experienceTracker.abort({
                name: $0c33e41081c1500e$var$EXPERIENCE_NAME,
                reason: 'Canceled by user'
            });
            setLoading(false);
            showExtension(null);
        }
    }, [
        loadExtension,
        experienceTracker
    ]);
    const onLoadCompleteCB = (0, $42omo.useCallback)(()=>{
        onLoadComplete();
        setLoading(false);
    }, [
        onLoadComplete,
        setLoading
    ]);
    const onCloseCB = (0, $42omo.useCallback)(()=>{
        showExtension(null);
    }, [
        showExtension
    ]);
    const onForgeExtensionClick = (0, $42omo.useCallback)((ext)=>{
        experienceTracker.start({
            name: $0c33e41081c1500e$var$EXPERIENCE_NAME,
            id: ext.id,
            timeout: 10000
        });
        showExtension(ext);
        setLoading(true);
    }, [
        showExtension,
        setLoading,
        experienceTracker
    ]);
    // shows up when preloaded in SSR. Shows up again when SPA takes over bf all queries are loaded.
    const LazyLoader = (0, $42omo.useMemo)(()=>(0, $dizL5.lazyForgeUIExtensionsWithLoader)(()=>lazyLoaderPlaceholderComponent ?? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9MrOn.ContentToolsButton // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
            ), {
                isDisabled: !(window.__SSR_RENDERED__ || undefined)
            })), // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, loadExtension && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0c33e41081c1500e$var$ForgeUIExtensionLoader, {
        extension: extension,
        contentId: contentId,
        spaceKey: spaceKey,
        onLoadComplete: onLoadCompleteCB,
        onClose: onCloseCB
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(LazyLoader, {
        moduleType: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
        render: (extensions, loading, error)=>{
            if (loading) return children([]);
            if (error) {
                if (!(0, $7Sm4c.isErrorMarkedAsHandled)(error)) (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                    attribution: (0, $3IBnw.Attribution).ECOSYSTEM
                });
                return children([]);
            }
            const result = extensions.map((ext)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ced39bfea5ef5993$export$9f275aff884e1431), {
                    key: ext.id,
                    extension: ext,
                    onClick: onForgeExtensionClick,
                    isLoading: extension === ext
                }));
            return children(result);
        }
    }));
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0c33e41081c1500e$var$InvisibleDiv = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0cglyw",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); /**
     * LazyForgeUIExtension has its own loading spinner, however, we don't want to show it anywhere. We want to show a
     * loading spinner inside the menu item while loading the extension, and then close the menu once the loading is complete.
     * To accomplish that, we're rendering LazyForgeUIExtension inside an invisible div.
     * @param forgeExtension To be loaded.
     * @param contentId Passed down to ForgeUIExtension both contentId and spaceKey becomes available in the forge app with
     * `useProductContext` hook. For reference https://developer.atlassian.com/platform/forge/ui-hooks-reference/.
     * @param spaceKey Passed down to ForgeUIExtension.
     * @param onLoadComplete Triggered when the forge extension is loaded.
     * @param onClose Triggered when the rendered ModalDialog is closed. (Currently ContentAction forge component can only contain a ModalDialog)
     * @returns LazyForgeUIExtension inside an InvisibleDiv.
     * @constructor
     */ 
function $0c33e41081c1500e$var$ForgeUIExtensionLoader(t0) {
    const $ = (0, $frIzR.c)(33);
    const { extension: extension, contentId: contentId, spaceKey: spaceAlias, onLoadComplete: onLoadComplete, onClose: onClose } = t0;
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const [t1] = (0, $ep3mz.usePageState)();
    const { routeName: routeName } = t1;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { activationId: activationId } = (0, $bQm3c.useSessionData)();
    const { spaceId: spaceId, spaceKey: spaceKey } = (0, $6uUjl.useSpaceIdentifiers)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const { setIsCloseMenuDisabled: setIsCloseMenuDisabled } = (0, $c54hr.useMoreActionsMenuActions)();
    let t2;
    let t3;
    if ($[0] !== setIsCloseMenuDisabled) {
        t2 = ()=>{
            setIsCloseMenuDisabled(true);
            return ()=>{
                setIsCloseMenuDisabled(false);
            };
        };
        t3 = [
            setIsCloseMenuDisabled
        ];
        $[0] = setIsCloseMenuDisabled;
        $[1] = t2;
        $[2] = t3;
    } else {
        t2 = $[1];
        t3 = $[2];
    }
    (0, $42omo.useEffect)(t2, t3);
    let t4;
    if ($[3] !== activationId || $[4] !== contentId || $[5] !== createAnalyticsEvent || $[6] !== experienceTracker || $[7] !== extension || $[8] !== onLoadComplete || $[9] !== routeName || $[10] !== spaceAlias || $[11] !== spaceId) {
        t4 = ()=>{
            experienceTracker.succeed({
                name: $0c33e41081c1500e$var$EXPERIENCE_NAME
            });
            onLoadComplete();
            const appId = (0, $8a9Dm.getAppId)(extension);
            const analyticEvent = createAnalyticsEvent({
                type: "sendTrackEvent",
                data: {
                    action: "invoked",
                    actionSubject: "forgeExtension",
                    actionSubjectId: appId,
                    containerType: "space",
                    containerId: spaceId,
                    objectType: (0, $hIaUw.getContentType)(routeName),
                    objectId: contentId,
                    source: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
                    attributes: {
                        activationId: activationId,
                        appId: appId,
                        moduleType: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
                        moduleKey: (0, $8a9Dm.getModuleKey)(extension),
                        spaceType: (0, $6UqI3.getSpaceType)(spaceAlias),
                        spaceId: spaceId
                    }
                }
            });
            analyticEvent.fire();
        };
        $[3] = activationId;
        $[4] = contentId;
        $[5] = createAnalyticsEvent;
        $[6] = experienceTracker;
        $[7] = extension;
        $[8] = onLoadComplete;
        $[9] = routeName;
        $[10] = spaceAlias;
        $[11] = spaceId;
        $[12] = t4;
    } else t4 = $[12];
    const onInitialRender = t4;
    if (!spaceKey) return null;
    const t5 = extension.id;
    const t6 = isLivePage ? "live" : null;
    let t7;
    if ($[13] !== routeName) {
        t7 = (0, $hIaUw.getContentType)(routeName);
        $[13] = routeName;
        $[14] = t7;
    } else t7 = $[14];
    let t8;
    if ($[15] !== contentId || $[16] !== t6 || $[17] !== t7) {
        t8 = {
            id: contentId,
            subtype: t6,
            type: t7
        };
        $[15] = contentId;
        $[16] = t6;
        $[17] = t7;
        $[18] = t8;
    } else t8 = $[18];
    const t9 = spaceKey || spaceAlias;
    let t10;
    if ($[19] !== spaceId || $[20] !== t9) {
        t10 = {
            key: t9,
            id: spaceId
        };
        $[19] = spaceId;
        $[20] = t9;
        $[21] = t10;
    } else t10 = $[21];
    let t11;
    if ($[22] !== t10 || $[23] !== t8) {
        t11 = {
            type: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
            content: t8,
            space: t10
        };
        $[22] = t10;
        $[23] = t8;
        $[24] = t11;
    } else t11 = $[24];
    let t12;
    if ($[25] !== onClose || $[26] !== setIsCloseMenuDisabled) {
        t12 = ()=>{
            setIsCloseMenuDisabled(false);
            onClose();
        };
        $[25] = onClose;
        $[26] = setIsCloseMenuDisabled;
        $[27] = t12;
    } else t12 = $[27];
    let t13;
    if ($[28] !== extension || $[29] !== onInitialRender || $[30] !== t11 || $[31] !== t12) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0c33e41081c1500e$var$InvisibleDiv, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7QUD1.ContentActionForgeApp), {
            key: t5,
            app: extension,
            extensionData: t11,
            onInitialRender: onInitialRender,
            onTearDown: t12
        }));
        $[28] = extension;
        $[29] = onInitialRender;
        $[30] = t11;
        $[31] = t12;
        $[32] = t13;
    } else t13 = $[32];
    return t13;
}
$0c33e41081c1500e$var$ForgeUIExtensionLoader.propTypes = {
    extension: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object.isRequired,
    contentId: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string.isRequired,
    spaceKey: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string.isRequired,
    onLoadComplete: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired,
    onClose: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired
};
module.exports["ForgeContentTools"] = $0c33e41081c1500e$export$7cf22b806dbb23cb;

});

parcelRegister("7Ndnw", function(module, exports) {
const $af2b0e533822f413$export$77aa6bcc53373193 = 'confluence:contentBylineItem';
const $af2b0e533822f413$export$dfd79dc5aae7414d = 'confluence:contextMenu';
const $af2b0e533822f413$export$93827e7f1bb6974c = 'confluence:contentAction';
const $af2b0e533822f413$export$6a8e7521883fbbdb = 'confluence:fullPage';
const $af2b0e533822f413$export$931827627b89a6ba = 'confluence:globalPage';
const $af2b0e533822f413$export$109ae14a8174901f = 'confluence:globalSettings';
const $af2b0e533822f413$export$e31530da5c277984 = 'confluence:homepageFeed';
const $af2b0e533822f413$export$54edc26d40e1a8eb = 'confluence:pageBanner';
const $af2b0e533822f413$export$75695e15f2aab495 = 'confluence:spacePage';
const $af2b0e533822f413$export$f17386882264cfae = 'confluence:spaceSettings';
const $af2b0e533822f413$export$3e9f3e416c5066aa = 'confluence:customContent';
const $af2b0e533822f413$export$b9c5c98eb97dff92 = 'confluence:backgroundScript';
const $af2b0e533822f413$export$c0df8ab57c5edc2a = 'test:module';
const $af2b0e533822f413$export$769f3a278705a683 = 'xen:macro';
const $af2b0e533822f413$export$492ceb220fc48ad2 = [
    $af2b0e533822f413$export$6a8e7521883fbbdb,
    $af2b0e533822f413$export$931827627b89a6ba,
    $af2b0e533822f413$export$109ae14a8174901f,
    $af2b0e533822f413$export$e31530da5c277984,
    $af2b0e533822f413$export$b9c5c98eb97dff92
];
const $af2b0e533822f413$export$ec6cdf0e930aca0a = [
    $af2b0e533822f413$export$75695e15f2aab495,
    $af2b0e533822f413$export$f17386882264cfae,
    $af2b0e533822f413$export$3e9f3e416c5066aa
];
const $af2b0e533822f413$export$344b997b63ff6612 = [
    $af2b0e533822f413$export$77aa6bcc53373193,
    $af2b0e533822f413$export$dfd79dc5aae7414d,
    $af2b0e533822f413$export$93827e7f1bb6974c,
    $af2b0e533822f413$export$3e9f3e416c5066aa
];
module.exports["FORGE_MODULE_BYLINE"] = $af2b0e533822f413$export$77aa6bcc53373193;
module.exports["FORGE_MODULE_CONTEXT_MENU"] = $af2b0e533822f413$export$dfd79dc5aae7414d;
module.exports["FORGE_MODULE_CONTENT_ACTION"] = $af2b0e533822f413$export$93827e7f1bb6974c;
module.exports["FORGE_MODULE_GLOBAL_PAGE"] = $af2b0e533822f413$export$931827627b89a6ba;
module.exports["FORGE_MODULE_GLOBAL_SETTINGS"] = $af2b0e533822f413$export$109ae14a8174901f;
module.exports["FORGE_MODULE_HOMEPAGE_FEED"] = $af2b0e533822f413$export$e31530da5c277984;
module.exports["FORGE_MODULE_PAGE_BANNER"] = $af2b0e533822f413$export$54edc26d40e1a8eb;
module.exports["FORGE_MODULE_SPACE_PAGE"] = $af2b0e533822f413$export$75695e15f2aab495;
module.exports["FORGE_MODULE_SPACE_SETTINGS"] = $af2b0e533822f413$export$f17386882264cfae;
module.exports["FORGE_MODULE_CUSTOM_CONTENT"] = $af2b0e533822f413$export$3e9f3e416c5066aa;
module.exports["FORGE_MODULE_BACKGROUND_SCRIPT"] = $af2b0e533822f413$export$b9c5c98eb97dff92;
module.exports["FORGE_MODULE_XEN_MACRO"] = $af2b0e533822f413$export$769f3a278705a683;

});

parcelRegister("7QUD1", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $02976f123c8f8e25$export$d2159b9f3f077903 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "cPPBg",
    name: "ByLineForgeApp",
    loader: async ()=>(await (parcelRequire("eGBXI"))).ByLineForgeApp
});

const $02976f123c8f8e25$export$f900958ce7c4410f = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "uUYc7",
    name: "ContentActionForgeApp",
    loader: async ()=>(await (parcelRequire("9BoTf"))).ContentActionForgeApp
});

const $02976f123c8f8e25$export$79ed117743c6c2cf = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "YSsGA",
    name: "ContextMenuForgeApp",
    loader: async ()=>(await (parcelRequire("2AYdv"))).ContextMenuForgeApp
});

const $02976f123c8f8e25$export$b8ad4f58faf0ae = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "AI3JE",
    name: "FullPageForgeApp",
    loader: async ()=>(await (parcelRequire("h1JiG"))).FullPageForgeApp
});

const $02976f123c8f8e25$export$83db8797814193a8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "HPVuo",
    name: "GlobalPageForgeApp",
    loader: async ()=>(await (parcelRequire("der9a"))).GlobalPageForgeApp
});

const $02976f123c8f8e25$export$74528162c4c3828b = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "iEsk7",
    name: "GlobalSettingsForgeApp",
    loader: async ()=>(await (parcelRequire("6hzbh"))).GlobalSettingsForgeApp
});

const $02976f123c8f8e25$export$c8291e2d6d6adbf2 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "MWvHM",
    name: "HomepageFeedForgeApp",
    loader: async ()=>(await (parcelRequire("a5AXh"))).HomepageFeedForgeApp
});

const $02976f123c8f8e25$export$e8858129e933f7e8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "KHgoO",
    name: "SpaceSettingsForgeApp",
    loader: async ()=>(await (parcelRequire("itWvp"))).SpaceSettingsForgeApp
});

const $02976f123c8f8e25$export$60a905140138a1c8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "-3RXI",
    name: "SpacePageForgeApp",
    loader: async ()=>(await (parcelRequire("j3Gyw"))).SpacePageForgeApp
});

const $02976f123c8f8e25$export$578d0cbdb0ffa72e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "9Auod",
    name: "CustomContentForgeApp",
    loader: async ()=>(await (parcelRequire("2esj6"))).CustomContentForgeApp
});

const $02976f123c8f8e25$export$40d4b5cfa6c18ea7 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "zkdSh",
    name: "BackgroundScriptForgeApp",
    loader: async ()=>(await (parcelRequire("dm4kc"))).BackgroundScriptForgeApp
});

const $02976f123c8f8e25$export$c76787f94e0b1609 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "BA7en",
    name: "PageBannerForgeApp",
    loader: async ()=>(await (parcelRequire("hczTB"))).PageBannerForgeApp
});
module.exports["ByLineForgeApp"] = $02976f123c8f8e25$export$d2159b9f3f077903;
module.exports["ContentActionForgeApp"] = $02976f123c8f8e25$export$f900958ce7c4410f;
module.exports["ContextMenuForgeApp"] = $02976f123c8f8e25$export$79ed117743c6c2cf;
module.exports["GlobalPageForgeApp"] = $02976f123c8f8e25$export$83db8797814193a8;
module.exports["GlobalSettingsForgeApp"] = $02976f123c8f8e25$export$74528162c4c3828b;
module.exports["HomepageFeedForgeApp"] = $02976f123c8f8e25$export$c8291e2d6d6adbf2;
module.exports["SpaceSettingsForgeApp"] = $02976f123c8f8e25$export$e8858129e933f7e8;
module.exports["SpacePageForgeApp"] = $02976f123c8f8e25$export$60a905140138a1c8;
module.exports["CustomContentForgeApp"] = $02976f123c8f8e25$export$578d0cbdb0ffa72e;
module.exports["BackgroundScriptForgeApp"] = $02976f123c8f8e25$export$40d4b5cfa6c18ea7;
module.exports["PageBannerForgeApp"] = $02976f123c8f8e25$export$c76787f94e0b1609;

});

parcelRegister("eGBXI", function(module, exports) {

let $ab126f6951b539b8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ab126f6951b539b8$var$load("2YffH"),
    $ab126f6951b539b8$var$load("8Kivm"),
    $ab126f6951b539b8$var$load("cDulG"),
    $ab126f6951b539b8$var$load("a9MgC"),
    $ab126f6951b539b8$var$load("8lkiW"),
    $ab126f6951b539b8$var$load("iQ0Jm"),
    $ab126f6951b539b8$var$load("edaDG"),
    $ab126f6951b539b8$var$load("8Tr2S"),
    $ab126f6951b539b8$var$load("eBRUf"),
    $ab126f6951b539b8$var$load("8Vm0B"),
    $ab126f6951b539b8$var$load("6QICh"),
    $ab126f6951b539b8$var$load("h4Nf7"),
    $ab126f6951b539b8$var$load("7f9Fz"),
    $ab126f6951b539b8$var$load("8YSo7"),
    $ab126f6951b539b8$var$load("2NUMk"),
    $ab126f6951b539b8$var$load("4OTrY"),
    $ab126f6951b539b8$var$load("76iIp"),
    $ab126f6951b539b8$var$load("az9CK"),
    $ab126f6951b539b8$var$load("g9CVe"),
    $ab126f6951b539b8$var$load("3w411"),
    $ab126f6951b539b8$var$load("eY3St"),
    $ab126f6951b539b8$var$load("bkd4T"),
    $ab126f6951b539b8$var$load("6wr18"),
    $ab126f6951b539b8$var$load("kjZZD"),
    $ab126f6951b539b8$var$load("Wowvf"),
    $ab126f6951b539b8$var$load("kHOMt"),
    $ab126f6951b539b8$var$load("dRpV3"),
    $ab126f6951b539b8$var$load("ffEVr"),
    $ab126f6951b539b8$var$load("hhss7"),
    $ab126f6951b539b8$var$load("hGfPD"),
    $ab126f6951b539b8$var$load("7Gmjr"),
    $ab126f6951b539b8$var$load("6u1hm"),
    $ab126f6951b539b8$var$load("5JyhW"),
    $ab126f6951b539b8$var$load("Br0Hw"),
    $ab126f6951b539b8$var$load("GuKfo"),
    $ab126f6951b539b8$var$load("5ZwKh"),
    $ab126f6951b539b8$var$load("iqKwT"),
    $ab126f6951b539b8$var$load("3GR0Y"),
    $ab126f6951b539b8$var$load("jEmf3"),
    $ab126f6951b539b8$var$load("kUbUu"),
    $ab126f6951b539b8$var$load("2PePB"),
    $ab126f6951b539b8$var$load("lnKog"),
    $ab126f6951b539b8$var$load("9ftJe"),
    $ab126f6951b539b8$var$load("h3ABO"),
    $ab126f6951b539b8$var$load("kC80R"),
    $ab126f6951b539b8$var$load("7EorR"),
    $ab126f6951b539b8$var$load("bGzhS")
]).then(()=>parcelRequire('5soYL'));

});

parcelRegister("9BoTf", function(module, exports) {

let $6fdae0691bcf6915$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6fdae0691bcf6915$var$load("2YffH"),
    $6fdae0691bcf6915$var$load("8Kivm"),
    $6fdae0691bcf6915$var$load("cDulG"),
    $6fdae0691bcf6915$var$load("a9MgC"),
    $6fdae0691bcf6915$var$load("8lkiW"),
    $6fdae0691bcf6915$var$load("iQ0Jm"),
    $6fdae0691bcf6915$var$load("edaDG"),
    $6fdae0691bcf6915$var$load("8Tr2S"),
    $6fdae0691bcf6915$var$load("eBRUf"),
    $6fdae0691bcf6915$var$load("8Vm0B"),
    $6fdae0691bcf6915$var$load("6QICh"),
    $6fdae0691bcf6915$var$load("h4Nf7"),
    $6fdae0691bcf6915$var$load("7f9Fz"),
    $6fdae0691bcf6915$var$load("8YSo7"),
    $6fdae0691bcf6915$var$load("2NUMk"),
    $6fdae0691bcf6915$var$load("4OTrY"),
    $6fdae0691bcf6915$var$load("76iIp"),
    $6fdae0691bcf6915$var$load("az9CK"),
    $6fdae0691bcf6915$var$load("g9CVe"),
    $6fdae0691bcf6915$var$load("3w411"),
    $6fdae0691bcf6915$var$load("eY3St"),
    $6fdae0691bcf6915$var$load("bkd4T"),
    $6fdae0691bcf6915$var$load("6wr18"),
    $6fdae0691bcf6915$var$load("kjZZD"),
    $6fdae0691bcf6915$var$load("Wowvf"),
    $6fdae0691bcf6915$var$load("kHOMt"),
    $6fdae0691bcf6915$var$load("dRpV3"),
    $6fdae0691bcf6915$var$load("ffEVr"),
    $6fdae0691bcf6915$var$load("hhss7"),
    $6fdae0691bcf6915$var$load("hGfPD"),
    $6fdae0691bcf6915$var$load("7Gmjr"),
    $6fdae0691bcf6915$var$load("6u1hm"),
    $6fdae0691bcf6915$var$load("5JyhW"),
    $6fdae0691bcf6915$var$load("Br0Hw"),
    $6fdae0691bcf6915$var$load("GuKfo"),
    $6fdae0691bcf6915$var$load("5ZwKh"),
    $6fdae0691bcf6915$var$load("iqKwT"),
    $6fdae0691bcf6915$var$load("3GR0Y"),
    $6fdae0691bcf6915$var$load("jEmf3"),
    $6fdae0691bcf6915$var$load("kUbUu"),
    $6fdae0691bcf6915$var$load("2PePB"),
    $6fdae0691bcf6915$var$load("lnKog"),
    $6fdae0691bcf6915$var$load("9ftJe"),
    $6fdae0691bcf6915$var$load("h3ABO"),
    $6fdae0691bcf6915$var$load("kC80R"),
    $6fdae0691bcf6915$var$load("7EorR"),
    $6fdae0691bcf6915$var$load("bdzih")
]).then(()=>parcelRequire('kXBs1'));

});

parcelRegister("2AYdv", function(module, exports) {

let $1e3da76181dbf6c3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $1e3da76181dbf6c3$var$load("2YffH"),
    $1e3da76181dbf6c3$var$load("8Kivm"),
    $1e3da76181dbf6c3$var$load("cDulG"),
    $1e3da76181dbf6c3$var$load("a9MgC"),
    $1e3da76181dbf6c3$var$load("8lkiW"),
    $1e3da76181dbf6c3$var$load("iQ0Jm"),
    $1e3da76181dbf6c3$var$load("edaDG"),
    $1e3da76181dbf6c3$var$load("8Tr2S"),
    $1e3da76181dbf6c3$var$load("eBRUf"),
    $1e3da76181dbf6c3$var$load("8Vm0B"),
    $1e3da76181dbf6c3$var$load("6QICh"),
    $1e3da76181dbf6c3$var$load("h4Nf7"),
    $1e3da76181dbf6c3$var$load("7f9Fz"),
    $1e3da76181dbf6c3$var$load("8YSo7"),
    $1e3da76181dbf6c3$var$load("2NUMk"),
    $1e3da76181dbf6c3$var$load("4OTrY"),
    $1e3da76181dbf6c3$var$load("76iIp"),
    $1e3da76181dbf6c3$var$load("az9CK"),
    $1e3da76181dbf6c3$var$load("g9CVe"),
    $1e3da76181dbf6c3$var$load("3w411"),
    $1e3da76181dbf6c3$var$load("eY3St"),
    $1e3da76181dbf6c3$var$load("bkd4T"),
    $1e3da76181dbf6c3$var$load("6wr18"),
    $1e3da76181dbf6c3$var$load("kjZZD"),
    $1e3da76181dbf6c3$var$load("Wowvf"),
    $1e3da76181dbf6c3$var$load("kHOMt"),
    $1e3da76181dbf6c3$var$load("dRpV3"),
    $1e3da76181dbf6c3$var$load("ffEVr"),
    $1e3da76181dbf6c3$var$load("hhss7"),
    $1e3da76181dbf6c3$var$load("hGfPD"),
    $1e3da76181dbf6c3$var$load("7Gmjr"),
    $1e3da76181dbf6c3$var$load("6u1hm"),
    $1e3da76181dbf6c3$var$load("5JyhW"),
    $1e3da76181dbf6c3$var$load("Br0Hw"),
    $1e3da76181dbf6c3$var$load("GuKfo"),
    $1e3da76181dbf6c3$var$load("5ZwKh"),
    $1e3da76181dbf6c3$var$load("iqKwT"),
    $1e3da76181dbf6c3$var$load("3GR0Y"),
    $1e3da76181dbf6c3$var$load("jEmf3"),
    $1e3da76181dbf6c3$var$load("kUbUu"),
    $1e3da76181dbf6c3$var$load("2PePB"),
    $1e3da76181dbf6c3$var$load("lnKog"),
    $1e3da76181dbf6c3$var$load("9ftJe"),
    $1e3da76181dbf6c3$var$load("h3ABO"),
    $1e3da76181dbf6c3$var$load("kC80R"),
    $1e3da76181dbf6c3$var$load("7EorR"),
    $1e3da76181dbf6c3$var$load("cwpVK")
]).then(()=>parcelRequire('1yxl3'));

});

parcelRegister("h1JiG", function(module, exports) {

let $c655ab5b273d1c84$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c655ab5b273d1c84$var$load("76iIp"),
    $c655ab5b273d1c84$var$load("az9CK"),
    $c655ab5b273d1c84$var$load("2YffH"),
    $c655ab5b273d1c84$var$load("cDulG"),
    $c655ab5b273d1c84$var$load("a9MgC"),
    $c655ab5b273d1c84$var$load("8lkiW"),
    $c655ab5b273d1c84$var$load("2PePB"),
    $c655ab5b273d1c84$var$load("edaDG"),
    $c655ab5b273d1c84$var$load("eBRUf"),
    $c655ab5b273d1c84$var$load("8Vm0B"),
    $c655ab5b273d1c84$var$load("6QICh"),
    $c655ab5b273d1c84$var$load("h4Nf7"),
    $c655ab5b273d1c84$var$load("7f9Fz"),
    $c655ab5b273d1c84$var$load("8YSo7"),
    $c655ab5b273d1c84$var$load("2NUMk"),
    $c655ab5b273d1c84$var$load("4OTrY"),
    $c655ab5b273d1c84$var$load("g9CVe"),
    $c655ab5b273d1c84$var$load("3w411"),
    $c655ab5b273d1c84$var$load("eY3St"),
    $c655ab5b273d1c84$var$load("bkd4T"),
    $c655ab5b273d1c84$var$load("6wr18"),
    $c655ab5b273d1c84$var$load("kjZZD"),
    $c655ab5b273d1c84$var$load("Wowvf"),
    $c655ab5b273d1c84$var$load("kHOMt"),
    $c655ab5b273d1c84$var$load("dRpV3"),
    $c655ab5b273d1c84$var$load("ffEVr"),
    $c655ab5b273d1c84$var$load("hhss7"),
    $c655ab5b273d1c84$var$load("hGfPD"),
    $c655ab5b273d1c84$var$load("7Gmjr"),
    $c655ab5b273d1c84$var$load("6u1hm"),
    $c655ab5b273d1c84$var$load("5JyhW"),
    $c655ab5b273d1c84$var$load("Br0Hw"),
    $c655ab5b273d1c84$var$load("GuKfo"),
    $c655ab5b273d1c84$var$load("5ZwKh"),
    $c655ab5b273d1c84$var$load("iqKwT"),
    $c655ab5b273d1c84$var$load("3GR0Y"),
    $c655ab5b273d1c84$var$load("jEmf3"),
    $c655ab5b273d1c84$var$load("kUbUu"),
    $c655ab5b273d1c84$var$load("9ftJe"),
    $c655ab5b273d1c84$var$load("h3ABO"),
    $c655ab5b273d1c84$var$load("kC80R"),
    $c655ab5b273d1c84$var$load("7EorR"),
    $c655ab5b273d1c84$var$load("68RC4")
]).then(()=>parcelRequire('f6dwD'));

});

parcelRegister("der9a", function(module, exports) {

let $9a21a3f38739b2cb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $9a21a3f38739b2cb$var$load("76iIp"),
    $9a21a3f38739b2cb$var$load("az9CK"),
    $9a21a3f38739b2cb$var$load("2YffH"),
    $9a21a3f38739b2cb$var$load("cDulG"),
    $9a21a3f38739b2cb$var$load("a9MgC"),
    $9a21a3f38739b2cb$var$load("8lkiW"),
    $9a21a3f38739b2cb$var$load("2PePB"),
    $9a21a3f38739b2cb$var$load("edaDG"),
    $9a21a3f38739b2cb$var$load("eBRUf"),
    $9a21a3f38739b2cb$var$load("8Vm0B"),
    $9a21a3f38739b2cb$var$load("6QICh"),
    $9a21a3f38739b2cb$var$load("h4Nf7"),
    $9a21a3f38739b2cb$var$load("7f9Fz"),
    $9a21a3f38739b2cb$var$load("8YSo7"),
    $9a21a3f38739b2cb$var$load("2NUMk"),
    $9a21a3f38739b2cb$var$load("4OTrY"),
    $9a21a3f38739b2cb$var$load("g9CVe"),
    $9a21a3f38739b2cb$var$load("3w411"),
    $9a21a3f38739b2cb$var$load("eY3St"),
    $9a21a3f38739b2cb$var$load("bkd4T"),
    $9a21a3f38739b2cb$var$load("6wr18"),
    $9a21a3f38739b2cb$var$load("kjZZD"),
    $9a21a3f38739b2cb$var$load("Wowvf"),
    $9a21a3f38739b2cb$var$load("kHOMt"),
    $9a21a3f38739b2cb$var$load("dRpV3"),
    $9a21a3f38739b2cb$var$load("ffEVr"),
    $9a21a3f38739b2cb$var$load("hhss7"),
    $9a21a3f38739b2cb$var$load("hGfPD"),
    $9a21a3f38739b2cb$var$load("7Gmjr"),
    $9a21a3f38739b2cb$var$load("6u1hm"),
    $9a21a3f38739b2cb$var$load("5JyhW"),
    $9a21a3f38739b2cb$var$load("Br0Hw"),
    $9a21a3f38739b2cb$var$load("GuKfo"),
    $9a21a3f38739b2cb$var$load("5ZwKh"),
    $9a21a3f38739b2cb$var$load("iqKwT"),
    $9a21a3f38739b2cb$var$load("3GR0Y"),
    $9a21a3f38739b2cb$var$load("jEmf3"),
    $9a21a3f38739b2cb$var$load("kUbUu"),
    $9a21a3f38739b2cb$var$load("9ftJe"),
    $9a21a3f38739b2cb$var$load("h3ABO"),
    $9a21a3f38739b2cb$var$load("kC80R"),
    $9a21a3f38739b2cb$var$load("7EorR"),
    $9a21a3f38739b2cb$var$load("87cDu")
]).then(()=>parcelRequire('iChZx'));

});

parcelRegister("6hzbh", function(module, exports) {

let $492f9ecda511095b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $492f9ecda511095b$var$load("76iIp"),
    $492f9ecda511095b$var$load("az9CK"),
    $492f9ecda511095b$var$load("2YffH"),
    $492f9ecda511095b$var$load("cDulG"),
    $492f9ecda511095b$var$load("a9MgC"),
    $492f9ecda511095b$var$load("8lkiW"),
    $492f9ecda511095b$var$load("2PePB"),
    $492f9ecda511095b$var$load("edaDG"),
    $492f9ecda511095b$var$load("eBRUf"),
    $492f9ecda511095b$var$load("8Vm0B"),
    $492f9ecda511095b$var$load("6QICh"),
    $492f9ecda511095b$var$load("h4Nf7"),
    $492f9ecda511095b$var$load("7f9Fz"),
    $492f9ecda511095b$var$load("8YSo7"),
    $492f9ecda511095b$var$load("2NUMk"),
    $492f9ecda511095b$var$load("4OTrY"),
    $492f9ecda511095b$var$load("g9CVe"),
    $492f9ecda511095b$var$load("3w411"),
    $492f9ecda511095b$var$load("eY3St"),
    $492f9ecda511095b$var$load("bkd4T"),
    $492f9ecda511095b$var$load("6wr18"),
    $492f9ecda511095b$var$load("kjZZD"),
    $492f9ecda511095b$var$load("Wowvf"),
    $492f9ecda511095b$var$load("kHOMt"),
    $492f9ecda511095b$var$load("dRpV3"),
    $492f9ecda511095b$var$load("ffEVr"),
    $492f9ecda511095b$var$load("hhss7"),
    $492f9ecda511095b$var$load("hGfPD"),
    $492f9ecda511095b$var$load("7Gmjr"),
    $492f9ecda511095b$var$load("6u1hm"),
    $492f9ecda511095b$var$load("5JyhW"),
    $492f9ecda511095b$var$load("Br0Hw"),
    $492f9ecda511095b$var$load("GuKfo"),
    $492f9ecda511095b$var$load("5ZwKh"),
    $492f9ecda511095b$var$load("iqKwT"),
    $492f9ecda511095b$var$load("3GR0Y"),
    $492f9ecda511095b$var$load("jEmf3"),
    $492f9ecda511095b$var$load("kUbUu"),
    $492f9ecda511095b$var$load("9ftJe"),
    $492f9ecda511095b$var$load("h3ABO"),
    $492f9ecda511095b$var$load("kC80R"),
    $492f9ecda511095b$var$load("7EorR"),
    $492f9ecda511095b$var$load("iXr0W")
]).then(()=>parcelRequire('671JL'));

});

parcelRegister("a5AXh", function(module, exports) {

let $75870988236ba95c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $75870988236ba95c$var$load("76iIp"),
    $75870988236ba95c$var$load("az9CK"),
    $75870988236ba95c$var$load("2YffH"),
    $75870988236ba95c$var$load("cDulG"),
    $75870988236ba95c$var$load("a9MgC"),
    $75870988236ba95c$var$load("8lkiW"),
    $75870988236ba95c$var$load("edaDG"),
    $75870988236ba95c$var$load("eBRUf"),
    $75870988236ba95c$var$load("8Vm0B"),
    $75870988236ba95c$var$load("6QICh"),
    $75870988236ba95c$var$load("h4Nf7"),
    $75870988236ba95c$var$load("7f9Fz"),
    $75870988236ba95c$var$load("8YSo7"),
    $75870988236ba95c$var$load("2NUMk"),
    $75870988236ba95c$var$load("4OTrY"),
    $75870988236ba95c$var$load("g9CVe"),
    $75870988236ba95c$var$load("3w411"),
    $75870988236ba95c$var$load("eY3St"),
    $75870988236ba95c$var$load("bkd4T"),
    $75870988236ba95c$var$load("6wr18"),
    $75870988236ba95c$var$load("kjZZD"),
    $75870988236ba95c$var$load("Wowvf"),
    $75870988236ba95c$var$load("kHOMt"),
    $75870988236ba95c$var$load("dRpV3"),
    $75870988236ba95c$var$load("ffEVr"),
    $75870988236ba95c$var$load("hhss7"),
    $75870988236ba95c$var$load("hGfPD"),
    $75870988236ba95c$var$load("7Gmjr"),
    $75870988236ba95c$var$load("6u1hm"),
    $75870988236ba95c$var$load("5JyhW"),
    $75870988236ba95c$var$load("Br0Hw"),
    $75870988236ba95c$var$load("GuKfo"),
    $75870988236ba95c$var$load("5ZwKh"),
    $75870988236ba95c$var$load("iqKwT"),
    $75870988236ba95c$var$load("3GR0Y"),
    $75870988236ba95c$var$load("jEmf3"),
    $75870988236ba95c$var$load("kUbUu"),
    $75870988236ba95c$var$load("2PePB"),
    $75870988236ba95c$var$load("lnKog"),
    $75870988236ba95c$var$load("9ftJe"),
    $75870988236ba95c$var$load("h3ABO"),
    $75870988236ba95c$var$load("kC80R"),
    $75870988236ba95c$var$load("7EorR"),
    $75870988236ba95c$var$load("ccJug")
]).then(()=>parcelRequire('k3MMo'));

});

parcelRegister("itWvp", function(module, exports) {

let $d748516d6d848ca8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $d748516d6d848ca8$var$load("2YffH"),
    $d748516d6d848ca8$var$load("cDulG"),
    $d748516d6d848ca8$var$load("a9MgC"),
    $d748516d6d848ca8$var$load("8lkiW"),
    $d748516d6d848ca8$var$load("edaDG"),
    $d748516d6d848ca8$var$load("8Tr2S"),
    $d748516d6d848ca8$var$load("eBRUf"),
    $d748516d6d848ca8$var$load("8Vm0B"),
    $d748516d6d848ca8$var$load("6QICh"),
    $d748516d6d848ca8$var$load("h4Nf7"),
    $d748516d6d848ca8$var$load("7f9Fz"),
    $d748516d6d848ca8$var$load("8YSo7"),
    $d748516d6d848ca8$var$load("2NUMk"),
    $d748516d6d848ca8$var$load("4OTrY"),
    $d748516d6d848ca8$var$load("76iIp"),
    $d748516d6d848ca8$var$load("az9CK"),
    $d748516d6d848ca8$var$load("g9CVe"),
    $d748516d6d848ca8$var$load("3w411"),
    $d748516d6d848ca8$var$load("eY3St"),
    $d748516d6d848ca8$var$load("bkd4T"),
    $d748516d6d848ca8$var$load("6wr18"),
    $d748516d6d848ca8$var$load("kjZZD"),
    $d748516d6d848ca8$var$load("Wowvf"),
    $d748516d6d848ca8$var$load("kHOMt"),
    $d748516d6d848ca8$var$load("dRpV3"),
    $d748516d6d848ca8$var$load("ffEVr"),
    $d748516d6d848ca8$var$load("dTsOE"),
    $d748516d6d848ca8$var$load("hhss7"),
    $d748516d6d848ca8$var$load("hGfPD"),
    $d748516d6d848ca8$var$load("7Gmjr"),
    $d748516d6d848ca8$var$load("6u1hm"),
    $d748516d6d848ca8$var$load("5JyhW"),
    $d748516d6d848ca8$var$load("Br0Hw"),
    $d748516d6d848ca8$var$load("GuKfo"),
    $d748516d6d848ca8$var$load("5ZwKh"),
    $d748516d6d848ca8$var$load("iqKwT"),
    $d748516d6d848ca8$var$load("3GR0Y"),
    $d748516d6d848ca8$var$load("jEmf3"),
    $d748516d6d848ca8$var$load("kUbUu"),
    $d748516d6d848ca8$var$load("2PePB"),
    $d748516d6d848ca8$var$load("lnKog"),
    $d748516d6d848ca8$var$load("9ftJe"),
    $d748516d6d848ca8$var$load("h3ABO"),
    $d748516d6d848ca8$var$load("kC80R"),
    $d748516d6d848ca8$var$load("7EorR"),
    $d748516d6d848ca8$var$load("irYLY")
]).then(()=>parcelRequire('aeos9'));

});

parcelRegister("j3Gyw", function(module, exports) {

let $ddff4ed9cbee5ab2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ddff4ed9cbee5ab2$var$load("2YffH"),
    $ddff4ed9cbee5ab2$var$load("cDulG"),
    $ddff4ed9cbee5ab2$var$load("a9MgC"),
    $ddff4ed9cbee5ab2$var$load("8lkiW"),
    $ddff4ed9cbee5ab2$var$load("edaDG"),
    $ddff4ed9cbee5ab2$var$load("8Tr2S"),
    $ddff4ed9cbee5ab2$var$load("eBRUf"),
    $ddff4ed9cbee5ab2$var$load("8Vm0B"),
    $ddff4ed9cbee5ab2$var$load("6QICh"),
    $ddff4ed9cbee5ab2$var$load("h4Nf7"),
    $ddff4ed9cbee5ab2$var$load("7f9Fz"),
    $ddff4ed9cbee5ab2$var$load("8YSo7"),
    $ddff4ed9cbee5ab2$var$load("2NUMk"),
    $ddff4ed9cbee5ab2$var$load("4OTrY"),
    $ddff4ed9cbee5ab2$var$load("76iIp"),
    $ddff4ed9cbee5ab2$var$load("az9CK"),
    $ddff4ed9cbee5ab2$var$load("g9CVe"),
    $ddff4ed9cbee5ab2$var$load("3w411"),
    $ddff4ed9cbee5ab2$var$load("eY3St"),
    $ddff4ed9cbee5ab2$var$load("bkd4T"),
    $ddff4ed9cbee5ab2$var$load("6wr18"),
    $ddff4ed9cbee5ab2$var$load("kjZZD"),
    $ddff4ed9cbee5ab2$var$load("Wowvf"),
    $ddff4ed9cbee5ab2$var$load("kHOMt"),
    $ddff4ed9cbee5ab2$var$load("dRpV3"),
    $ddff4ed9cbee5ab2$var$load("ffEVr"),
    $ddff4ed9cbee5ab2$var$load("dTsOE"),
    $ddff4ed9cbee5ab2$var$load("hhss7"),
    $ddff4ed9cbee5ab2$var$load("hGfPD"),
    $ddff4ed9cbee5ab2$var$load("7Gmjr"),
    $ddff4ed9cbee5ab2$var$load("6u1hm"),
    $ddff4ed9cbee5ab2$var$load("5JyhW"),
    $ddff4ed9cbee5ab2$var$load("Br0Hw"),
    $ddff4ed9cbee5ab2$var$load("GuKfo"),
    $ddff4ed9cbee5ab2$var$load("5ZwKh"),
    $ddff4ed9cbee5ab2$var$load("iqKwT"),
    $ddff4ed9cbee5ab2$var$load("3GR0Y"),
    $ddff4ed9cbee5ab2$var$load("jEmf3"),
    $ddff4ed9cbee5ab2$var$load("kUbUu"),
    $ddff4ed9cbee5ab2$var$load("2PePB"),
    $ddff4ed9cbee5ab2$var$load("lnKog"),
    $ddff4ed9cbee5ab2$var$load("9ftJe"),
    $ddff4ed9cbee5ab2$var$load("h3ABO"),
    $ddff4ed9cbee5ab2$var$load("kC80R"),
    $ddff4ed9cbee5ab2$var$load("7EorR"),
    $ddff4ed9cbee5ab2$var$load("ldtPf")
]).then(()=>parcelRequire('kWbxC'));

});

parcelRegister("2esj6", function(module, exports) {

let $1a02d8c2a643eeda$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $1a02d8c2a643eeda$var$load("76iIp"),
    $1a02d8c2a643eeda$var$load("az9CK"),
    $1a02d8c2a643eeda$var$load("2YffH"),
    $1a02d8c2a643eeda$var$load("cDulG"),
    $1a02d8c2a643eeda$var$load("a9MgC"),
    $1a02d8c2a643eeda$var$load("8lkiW"),
    $1a02d8c2a643eeda$var$load("2PePB"),
    $1a02d8c2a643eeda$var$load("edaDG"),
    $1a02d8c2a643eeda$var$load("eBRUf"),
    $1a02d8c2a643eeda$var$load("8Vm0B"),
    $1a02d8c2a643eeda$var$load("6QICh"),
    $1a02d8c2a643eeda$var$load("h4Nf7"),
    $1a02d8c2a643eeda$var$load("7f9Fz"),
    $1a02d8c2a643eeda$var$load("8YSo7"),
    $1a02d8c2a643eeda$var$load("2NUMk"),
    $1a02d8c2a643eeda$var$load("4OTrY"),
    $1a02d8c2a643eeda$var$load("g9CVe"),
    $1a02d8c2a643eeda$var$load("3w411"),
    $1a02d8c2a643eeda$var$load("eY3St"),
    $1a02d8c2a643eeda$var$load("bkd4T"),
    $1a02d8c2a643eeda$var$load("6wr18"),
    $1a02d8c2a643eeda$var$load("kjZZD"),
    $1a02d8c2a643eeda$var$load("Wowvf"),
    $1a02d8c2a643eeda$var$load("kHOMt"),
    $1a02d8c2a643eeda$var$load("dRpV3"),
    $1a02d8c2a643eeda$var$load("ffEVr"),
    $1a02d8c2a643eeda$var$load("hhss7"),
    $1a02d8c2a643eeda$var$load("hGfPD"),
    $1a02d8c2a643eeda$var$load("7Gmjr"),
    $1a02d8c2a643eeda$var$load("6u1hm"),
    $1a02d8c2a643eeda$var$load("5JyhW"),
    $1a02d8c2a643eeda$var$load("Br0Hw"),
    $1a02d8c2a643eeda$var$load("GuKfo"),
    $1a02d8c2a643eeda$var$load("5ZwKh"),
    $1a02d8c2a643eeda$var$load("iqKwT"),
    $1a02d8c2a643eeda$var$load("3GR0Y"),
    $1a02d8c2a643eeda$var$load("jEmf3"),
    $1a02d8c2a643eeda$var$load("kUbUu"),
    $1a02d8c2a643eeda$var$load("9ftJe"),
    $1a02d8c2a643eeda$var$load("h3ABO"),
    $1a02d8c2a643eeda$var$load("kC80R"),
    $1a02d8c2a643eeda$var$load("7EorR"),
    $1a02d8c2a643eeda$var$load("6wcNV")
]).then(()=>parcelRequire('iMf0a'));

});

parcelRegister("dm4kc", function(module, exports) {

let $9b90af41c76ae87f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $9b90af41c76ae87f$var$load("76iIp"),
    $9b90af41c76ae87f$var$load("az9CK"),
    $9b90af41c76ae87f$var$load("2YffH"),
    $9b90af41c76ae87f$var$load("cDulG"),
    $9b90af41c76ae87f$var$load("a9MgC"),
    $9b90af41c76ae87f$var$load("8lkiW"),
    $9b90af41c76ae87f$var$load("edaDG"),
    $9b90af41c76ae87f$var$load("eBRUf"),
    $9b90af41c76ae87f$var$load("8Vm0B"),
    $9b90af41c76ae87f$var$load("6QICh"),
    $9b90af41c76ae87f$var$load("h4Nf7"),
    $9b90af41c76ae87f$var$load("7f9Fz"),
    $9b90af41c76ae87f$var$load("8YSo7"),
    $9b90af41c76ae87f$var$load("2NUMk"),
    $9b90af41c76ae87f$var$load("4OTrY"),
    $9b90af41c76ae87f$var$load("g9CVe"),
    $9b90af41c76ae87f$var$load("3w411"),
    $9b90af41c76ae87f$var$load("eY3St"),
    $9b90af41c76ae87f$var$load("bkd4T"),
    $9b90af41c76ae87f$var$load("6wr18"),
    $9b90af41c76ae87f$var$load("kjZZD"),
    $9b90af41c76ae87f$var$load("Wowvf"),
    $9b90af41c76ae87f$var$load("kHOMt"),
    $9b90af41c76ae87f$var$load("dRpV3"),
    $9b90af41c76ae87f$var$load("ffEVr"),
    $9b90af41c76ae87f$var$load("hhss7"),
    $9b90af41c76ae87f$var$load("hGfPD"),
    $9b90af41c76ae87f$var$load("7Gmjr"),
    $9b90af41c76ae87f$var$load("6u1hm"),
    $9b90af41c76ae87f$var$load("5JyhW"),
    $9b90af41c76ae87f$var$load("Br0Hw"),
    $9b90af41c76ae87f$var$load("GuKfo"),
    $9b90af41c76ae87f$var$load("5ZwKh"),
    $9b90af41c76ae87f$var$load("iqKwT"),
    $9b90af41c76ae87f$var$load("3GR0Y"),
    $9b90af41c76ae87f$var$load("jEmf3"),
    $9b90af41c76ae87f$var$load("kUbUu"),
    $9b90af41c76ae87f$var$load("2PePB"),
    $9b90af41c76ae87f$var$load("lnKog"),
    $9b90af41c76ae87f$var$load("9ftJe"),
    $9b90af41c76ae87f$var$load("h3ABO"),
    $9b90af41c76ae87f$var$load("kC80R"),
    $9b90af41c76ae87f$var$load("7EorR"),
    $9b90af41c76ae87f$var$load("i9jMB")
]).then(()=>parcelRequire('estkk'));

});

parcelRegister("hczTB", function(module, exports) {

let $c85f66d44f3748f6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c85f66d44f3748f6$var$load("76iIp"),
    $c85f66d44f3748f6$var$load("az9CK"),
    $c85f66d44f3748f6$var$load("2YffH"),
    $c85f66d44f3748f6$var$load("cDulG"),
    $c85f66d44f3748f6$var$load("a9MgC"),
    $c85f66d44f3748f6$var$load("8lkiW"),
    $c85f66d44f3748f6$var$load("edaDG"),
    $c85f66d44f3748f6$var$load("eBRUf"),
    $c85f66d44f3748f6$var$load("8Vm0B"),
    $c85f66d44f3748f6$var$load("6QICh"),
    $c85f66d44f3748f6$var$load("h4Nf7"),
    $c85f66d44f3748f6$var$load("7f9Fz"),
    $c85f66d44f3748f6$var$load("8YSo7"),
    $c85f66d44f3748f6$var$load("2NUMk"),
    $c85f66d44f3748f6$var$load("4OTrY"),
    $c85f66d44f3748f6$var$load("g9CVe"),
    $c85f66d44f3748f6$var$load("3w411"),
    $c85f66d44f3748f6$var$load("eY3St"),
    $c85f66d44f3748f6$var$load("bkd4T"),
    $c85f66d44f3748f6$var$load("6wr18"),
    $c85f66d44f3748f6$var$load("kjZZD"),
    $c85f66d44f3748f6$var$load("Wowvf"),
    $c85f66d44f3748f6$var$load("kHOMt"),
    $c85f66d44f3748f6$var$load("dRpV3"),
    $c85f66d44f3748f6$var$load("ffEVr"),
    $c85f66d44f3748f6$var$load("hhss7"),
    $c85f66d44f3748f6$var$load("hGfPD"),
    $c85f66d44f3748f6$var$load("7Gmjr"),
    $c85f66d44f3748f6$var$load("6u1hm"),
    $c85f66d44f3748f6$var$load("5JyhW"),
    $c85f66d44f3748f6$var$load("Br0Hw"),
    $c85f66d44f3748f6$var$load("GuKfo"),
    $c85f66d44f3748f6$var$load("5ZwKh"),
    $c85f66d44f3748f6$var$load("iqKwT"),
    $c85f66d44f3748f6$var$load("3GR0Y"),
    $c85f66d44f3748f6$var$load("jEmf3"),
    $c85f66d44f3748f6$var$load("kUbUu"),
    $c85f66d44f3748f6$var$load("2PePB"),
    $c85f66d44f3748f6$var$load("lnKog"),
    $c85f66d44f3748f6$var$load("9ftJe"),
    $c85f66d44f3748f6$var$load("h3ABO"),
    $c85f66d44f3748f6$var$load("kC80R"),
    $c85f66d44f3748f6$var$load("7EorR"),
    $c85f66d44f3748f6$var$load("aFNXd")
]).then(()=>parcelRequire('cgoGN'));

});

parcelRegister("hIaUw", function(module, exports) {
const $5ff3d548ffdc5eda$export$1ef77878e4e0b972 = (routeName)=>{
    if (routeName?.includes('PAGE')) return 'page';
    if (routeName?.includes('BLOG')) return 'blogpost';
    if (routeName?.includes('SPACE')) return 'space';
    return 'page';
};
module.exports["getContentType"] = $5ff3d548ffdc5eda$export$1ef77878e4e0b972;

});

parcelRegister("8a9Dm", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");

const $2cc1b73219e08564$export$fb2283f4a44fb53 = (app)=>{
    if (!app?.id) return;
    const [, id] = app.id.split('/');
    return id;
};
const $2cc1b73219e08564$export$b17b21a48c0a3273 = (module)=>{
    if (!module.id) return;
    const parts = module.id.split('/');
    return parts[parts.length - 1];
};
const $2cc1b73219e08564$var$isMigratedFromConnect = (app)=>{
    if (!app.properties) return false;
    const props = app.properties;
    return props.migratedFromConnect === true || props.migratedFromConnect === 'true';
};
const $2cc1b73219e08564$export$9eb690901638fb96 = (app)=>{
    if ($2cc1b73219e08564$var$isMigratedFromConnect(app) && app.migrationKey && (0, $9wGTI.fg)('confluence-fe-migrated-custom-content-display-fix')) return `ac:${app.migrationKey}:${$2cc1b73219e08564$export$b17b21a48c0a3273(app)}`;
    return `forge:${$2cc1b73219e08564$export$fb2283f4a44fb53(app)}:${app.environmentId}:${$2cc1b73219e08564$export$b17b21a48c0a3273(app)}`;
};
module.exports["getAppId"] = $2cc1b73219e08564$export$fb2283f4a44fb53;
module.exports["getModuleKey"] = $2cc1b73219e08564$export$b17b21a48c0a3273;
module.exports["getCustomContentType"] = $2cc1b73219e08564$export$9eb690901638fb96;

});

parcelRegister("dizL5", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $55b20ed34f146485$export$350b371bfb7f5e95 = (loadingComponent)=>(0, $jmjWc.LoadableAfterPaint)({
        __loadable_id__: "UJdch",
        name: "lazyForgeUIExtensionsWithLoader",
        loader: async ()=>(await (parcelRequire("kxN5Y"))).ForgeUIExtensionsWrapper,
        loading: loadingComponent
    });
const $55b20ed34f146485$export$4cbc6d03d50a8849 = $55b20ed34f146485$export$350b371bfb7f5e95(undefined);
module.exports["lazyForgeUIExtensionsWithLoader"] = $55b20ed34f146485$export$350b371bfb7f5e95;
module.exports["LazyForgeUIExtensions"] = $55b20ed34f146485$export$4cbc6d03d50a8849;

});

parcelRegister("kxN5Y", function(module, exports) {

let $ef4cf9036132d263$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ef4cf9036132d263$var$load("2PePB"),
    $ef4cf9036132d263$var$load("lnKog")
]).then(()=>parcelRequire('2mcHd'));

});

parcelRegister("6UqI3", function(module, exports) {
const $a3c7cd489159fe33$export$28eddf802cd184f7 = (spaceKey)=>{
    return spaceKey?.[0] === '~' ? 'personal' : 'global';
};
module.exports["getSpaceType"] = $a3c7cd489159fe33$export$28eddf802cd184f7;

});

parcelRegister("c54hr", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $367766f6f044c46b$var$initialState = {
    isMenuOpen: false,
    isCloseMenuDisabled: false
};
const $367766f6f044c46b$var$actions = {
    setIsMenuOpen: (isMenuOpen)=>({ setState: setState })=>{
            setState({
                isMenuOpen: isMenuOpen
            });
        },
    setIsCloseMenuDisabled: (isCloseMenuDisabled)=>({ setState: setState })=>{
            setState({
                isCloseMenuDisabled: isCloseMenuDisabled
            });
        }
};
const $367766f6f044c46b$var$Store = (0, $1P1Tu.createStore)({
    initialState: $367766f6f044c46b$var$initialState,
    actions: $367766f6f044c46b$var$actions,
    name: 'more-actions-menu-store'
});
const $367766f6f044c46b$export$14d00db016c2b3ef = (0, $9zUhf.createStateHook)($367766f6f044c46b$var$Store);
const $367766f6f044c46b$export$1f1f8c486fa8a1cb = (0, $9zUhf.createActionsHook)($367766f6f044c46b$var$Store);
module.exports["useMoreActionsMenuState"] = $367766f6f044c46b$export$14d00db016c2b3ef;
module.exports["useMoreActionsMenuActions"] = $367766f6f044c46b$export$1f1f8c486fa8a1cb;

});

parcelRegister("9fBoq", function(module, exports) {
parcelRequire("1c598");
var $1Aku8 = parcelRequire("1Aku8");

const $6ca0453d93f30f16$var$capitalize = (str)=>{
    if (!str || !str.length) return '';
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};
const $6ca0453d93f30f16$export$9dd0cb91ff7c8b7e = (extension, overriddenTitle)=>{
    const title = overriddenTitle || extension.properties.title;
    const { environmentType: environmentType, environmentKey: environmentKey } = extension;
    if (environmentType === (0, $1Aku8.ProductEnvironment).PRODUCTION) return title;
    if (environmentType === (0, $1Aku8.ProductEnvironment).DEVELOPMENT && environmentKey !== 'default') return `${title} - ${environmentKey} (Dev)`;
    return `${title} (${$6ca0453d93f30f16$var$capitalize(environmentType)})`;
};
module.exports["extensionTitle"] = $6ca0453d93f30f16$export$9dd0cb91ff7c8b7e;

});

parcelRegister("1c598", function(module, exports) {
$parcel$export(module.exports, "ProductEnvironment", () => (parcelRequire("1Aku8")).ProductEnvironment);
$parcel$export(module.exports, "ForgeCDNEnvironment", () => (parcelRequire("1Aku8")).ForgeCDNEnvironment);
$parcel$export(module.exports, "ExtensionEnvironment", () => (parcelRequire("2JC3k")).ExtensionEnvironment);
$parcel$export(module.exports, "MarkupRecursiveList", () => (parcelRequire("9dbGT")).MarkupRecursiveList);
$parcel$export(module.exports, "MarkupList", () => (parcelRequire("9dbGT")).MarkupList);
$parcel$export(module.exports, "ConfluenceExtension", () => (parcelRequire("2JC3k")).ConfluenceExtension);
$parcel$export(module.exports, "JiraExtension", () => (parcelRequire("2JC3k")).JiraExtension);
parcelRequire("i3Ypo");
var $2JC3k = parcelRequire("2JC3k");
var $1Aku8 = parcelRequire("1Aku8");
var $9dbGT = parcelRequire("9dbGT");

parcelRequire("jUCNB");
var $gUjm2 = parcelRequire("gUjm2");
var $kg3OT = parcelRequire("kg3OT");
var $fsQJy = parcelRequire("fsQJy");


});

parcelRegister("i3Ypo", function(module, exports) {
$parcel$export(module.exports, "MarkupRecursiveList", () => (parcelRequire("9dbGT")).MarkupRecursiveList);
$parcel$export(module.exports, "MarkupList", () => (parcelRequire("9dbGT")).MarkupList);
$parcel$export(module.exports, "ProductEnvironment", () => (parcelRequire("1Aku8")).ProductEnvironment);
$parcel$export(module.exports, "ForgeCDNEnvironment", () => (parcelRequire("1Aku8")).ForgeCDNEnvironment);
$parcel$export(module.exports, "ConfluenceExtension", () => (parcelRequire("2JC3k")).ConfluenceExtension);
$parcel$export(module.exports, "ExtensionEnvironment", () => (parcelRequire("2JC3k")).ExtensionEnvironment);
$parcel$export(module.exports, "JiraExtension", () => (parcelRequire("2JC3k")).JiraExtension);

var $9dbGT = parcelRequire("9dbGT");


var $1Aku8 = parcelRequire("1Aku8");


var $6sM2K = parcelRequire("6sM2K");


var $2JC3k = parcelRequire("2JC3k");


});

parcelRegister("9dbGT", function(module, exports) {
const $1ec3e8240f57817b$export$3b98ab6402702476 = [
    'Em',
    'Link',
    'Strike',
    'String',
    'Strong',
    'User'
];
const $1ec3e8240f57817b$export$3ee8c58bb87b9685 = [
    ...$1ec3e8240f57817b$export$3b98ab6402702476,
    'Badge',
    'Code',
    'DateLozenge',
    'StatusLozenge',
    'Tag',
    'UserGroup'
];
module.exports["MarkupRecursiveList"] = $1ec3e8240f57817b$export$3b98ab6402702476;
module.exports["MarkupList"] = $1ec3e8240f57817b$export$3ee8c58bb87b9685;

});

parcelRegister("1Aku8", function(module, exports) {
var $d128cc36ec70c56c$export$2688cec3c24cb60b = /*#__PURE__*/ function(ProductEnvironment) {
    ProductEnvironment["DEVELOPMENT"] = "DEVELOPMENT";
    ProductEnvironment["STAGING"] = "STAGING";
    ProductEnvironment["PRODUCTION"] = "PRODUCTION";
    return ProductEnvironment;
}({});
var $d128cc36ec70c56c$export$beaef1891b3e7ca3 = /*#__PURE__*/ function(ForgeCDNEnvironment) {
    ForgeCDNEnvironment["DEVELOPMENT"] = "dev";
    ForgeCDNEnvironment["STAGING"] = "stg";
    ForgeCDNEnvironment["PRODUCTION"] = "prod";
    return ForgeCDNEnvironment;
}({});
module.exports["ProductEnvironment"] = $d128cc36ec70c56c$export$2688cec3c24cb60b;
module.exports["ForgeCDNEnvironment"] = $d128cc36ec70c56c$export$beaef1891b3e7ca3;

});

parcelRegister("6sM2K", function(module, exports) {
const $0e3337cb4407ef3b$export$21b318cfdd670495 = (error)=>({
        type: 'render',
        aux: {
            type: 'View',
            children: [
                {
                    type: 'ErrorPanel',
                    props: {
                        error: error
                    },
                    children: []
                }
            ]
        },
        state: {}
    });

});

parcelRegister("2JC3k", function(module, exports) {
var $d977f97374f9d2c9$export$6e95f5308d9156f9 = /*#__PURE__*/ function(ExtensionEnvironment) {
    ExtensionEnvironment["DEVELOPMENT"] = "DEVELOPMENT";
    ExtensionEnvironment["STAGING"] = "STAGING";
    ExtensionEnvironment["PRODUCTION"] = "PRODUCTION";
    return ExtensionEnvironment;
}({});
const $d977f97374f9d2c9$export$9a2372818e2520c6 = {
    BYLINE: 'confluence:contentBylineItem',
    CONTEXT_MENU: 'confluence:contextMenu',
    CONTENT_ACTION: 'confluence:contentAction',
    GLOBAL_PAGE: 'confluence:globalPage',
    GLOBAL_SETTINGS: 'confluence:globalSettings',
    HOMEPAGE_FEED: 'confluence:homepageFeed',
    SPACE_PAGE: 'confluence:spacePage',
    SPACE_SETTINGS: 'confluence:spaceSettings',
    CUSTOM_CONTENT: 'confluence:customContent',
    MACRO: 'xen:macro',
    TEST_MODULE: 'test:module'
};
const $d977f97374f9d2c9$export$f06ffa3aa6bfec95 = {
    BACKLOG_ACTION: 'jira:backlogAction',
    BOARD_ACTION: 'jira:boardAction',
    PERSONAL_SETTINGS_PAGE: 'jira:personalSettingsPage',
    ISSUE_PANEL: 'jira:issuePanel',
    ISSUE_ACTION: 'jira:issueAction',
    ISSUE_GLANCE: 'jira:issueGlance',
    ISSUE_CONTEXT: 'jira:issueContext',
    ISSUE_ACTIVITY: 'jira:issueActivity',
    UI_MODIFICATIONS: 'jira:uiModifications',
    CUSTOM_FIELD: 'jira:customField',
    CUSTOM_FIELD_TYPE: 'jira:customFieldType',
    ADMIN_PAGE: 'jira:adminPage',
    GLOBAL_PAGE: 'jira:globalPage',
    PROJECT_PAGE: 'jira:projectPage',
    PROJECT_SETTINGS_PAGE: 'jira:projectSettingsPage',
    DASHBOARD_BACKGROUND_SCRIPT: 'jira:dashboardBackgroundScript',
    ISSUE_VIEW_BACKGROUND_SCRIPT: 'jira:issueViewBackgroundScript',
    DASHBOARD_GADGET: 'jira:dashboardGadget',
    WORKFLOW_VALIDATOR: 'jira:workflowValidator',
    WORKFLOW_CONDITION: 'jira:workflowCondition',
    WORKFLOW_POST_FUNCTION: 'jira:workflowPostFunction',
    SERVICE_DESK_QUEUE_PAGE: 'jiraServiceManagement:queuePage',
    SERVICE_DESK_ORGANIZATION_PANEL: 'jiraServiceManagement:organizationPanel'
};
module.exports["ExtensionEnvironment"] = $d977f97374f9d2c9$export$6e95f5308d9156f9;
module.exports["ConfluenceExtension"] = $d977f97374f9d2c9$export$9a2372818e2520c6;
module.exports["JiraExtension"] = $d977f97374f9d2c9$export$f06ffa3aa6bfec95;

});

parcelRegister("jUCNB", function(module, exports) {

var $fsQJy = parcelRequire("fsQJy");


var $kg3OT = parcelRequire("kg3OT");


var $gUjm2 = parcelRequire("gUjm2");


});

parcelRegister("fsQJy", function(module, exports) {
// DELETE FILE http://go/j/FUI-1091
const $8d78496ee677e86d$export$7e816460364ed464 = (effect)=>{
    return effect.type === 'initialize';
};
const $8d78496ee677e86d$export$eb5bd7f371e458af = (effect)=>{
    return effect.type === 'action';
};
const $8d78496ee677e86d$export$f632ad3064955f31 = (effect)=>{
    return effect.type === 'event';
};
const $8d78496ee677e86d$export$dfeb34e64fee2572 = (effect)=>{
    return effect.type === 'render';
};
function $8d78496ee677e86d$export$20b9f6acb0888554(effect) {
    return $8d78496ee677e86d$export$7e816460364ed464(effect) || $8d78496ee677e86d$export$eb5bd7f371e458af(effect) || $8d78496ee677e86d$export$f632ad3064955f31(effect);
}

});

parcelRegister("kg3OT", function(module, exports) {
const $bc3454970f51a505$export$709a27a9f80556b8 = (effect)=>{
    return effect.type === 'event';
};
const $bc3454970f51a505$export$65d7078e01574f24 = (effect)=>{
    return effect.type === 'action';
};
const $bc3454970f51a505$export$8089f608f1d0c22d = (effect)=>{
    return effect.type === 'render';
};
const $bc3454970f51a505$export$84909efba3133df = (effect)=>{
    return effect.type === 'result';
};
function $bc3454970f51a505$export$caa8cab0db5b0a61(effect) {
    return $bc3454970f51a505$export$65d7078e01574f24(effect) || $bc3454970f51a505$export$709a27a9f80556b8(effect) || $bc3454970f51a505$export$8089f608f1d0c22d(effect);
}

});

parcelRegister("gUjm2", function(module, exports) {
// From forge.ts
const $ce9f8921033c0d6d$export$3ab8eca5875a9c7e = (auxNode)=>{
    return auxNode !== null && typeof auxNode !== 'boolean' && auxNode !== undefined;
};
var $ce9f8921033c0d6d$export$c8914e6b1e019577 = /*#__PURE__*/ function(EcosystemLicenseMode) {
    EcosystemLicenseMode["USER_ACCESS"] = "USER_ACCESS";
    return EcosystemLicenseMode;
}({});
const $ce9f8921033c0d6d$export$a3b8d8814f1b9262 = (context)=>context.type === 'jira';
const $ce9f8921033c0d6d$export$d8e8de7bd6b731b7 = (extensionContext)=>extensionContext.type === 'issuePanel';
const $ce9f8921033c0d6d$export$1404d10ac8f82a03 = (extensionContext)=>extensionContext.type === 'contextConfig';
const $ce9f8921033c0d6d$export$9e5e0ca9e718a261 = (extensionContext)=>extensionContext.type === 'customField' || extensionContext.type === 'customFieldType';
const $ce9f8921033c0d6d$export$2f4ddb77a2467d4a = (extensionContext)=>extensionContext.type === 'contextMenu';
const $ce9f8921033c0d6d$export$dfe2b8f5623b1a39 = (extensionContext)=>extensionContext.type === 'contentAction';
const $ce9f8921033c0d6d$export$aee7a41cc3ed0e4 = (extensionContext)=>extensionContext.type === 'dashboardGadget';
var $ce9f8921033c0d6d$export$24835b97bd9481e3 = /*#__PURE__*/ function(CompassContextTypes) {
    CompassContextTypes["AdminPage"] = "compass:adminPage";
    CompassContextTypes["ComponentPage"] = "compass:componentPage";
    CompassContextTypes["TeamPage"] = "compass:teamPage";
    CompassContextTypes["ComponentImporter"] = "compass:componentImporter";
    return CompassContextTypes;
}({});
var $ce9f8921033c0d6d$export$1718b7e1799fa866 = /*#__PURE__*/ function(RenderingLocations) {
    RenderingLocations["AppConfigurationPage"] = "appConfigurationPage";
    RenderingLocations["OnboardingFlow"] = "onboardingFlow";
    return RenderingLocations;
}({});

});

parcelRegister("9MrOn", function(module, exports) {
/* ContentToolsButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $4xcIM = parcelRequire("4xcIM");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $9VJDA = parcelRequire("9VJDA");


var $1qfLF = parcelRequire("1qfLF");


var $52EPl = parcelRequire("52EPl");

const $43c0d8bb08806c39$var$NOOP = ()=>{};
const $43c0d8bb08806c39$var$i18n = (0, $cgtv4.defineMessages)({
    triggerLabel: {
        id: "content-tools.more.icon.label",
        defaultMessage: "More actions"
    }
});
const $43c0d8bb08806c39$var$dropdownMenuCollaboratorStyle = null;
const $43c0d8bb08806c39$var$dropdownMenuNonCollaboratorStyle = null;
const $43c0d8bb08806c39$var$ContentToolsButtonComponent = ({ isDisabled: isDisabled, isOpen: isOpen = false, onOpenChange: onOpenChange = $43c0d8bb08806c39$var$NOOP, onPositioned: onPositioned = $43c0d8bb08806c39$var$NOOP, children: children, isExternalCollaborator: isExternalCollaborator = false })=>{
    'use no memo';
    const intl = (0, $8C5kA.default)();
    const [drodownMenuMaxHeight, setDropdownMenuMaxHeight] = (0, $42omo.useState)('auto');
    const dropdownMenuContainerRef = (0, $42omo.useRef)(null);
    const handleOnOpenChange = (obj)=>{
        onOpenChange(obj);
        if (obj.isOpen) {
            const distanceFromTop = dropdownMenuContainerRef.current?.getBoundingClientRect().bottom ?? 0;
            const availableHeight = window.innerHeight - distanceFromTop - 16;
            setDropdownMenuMaxHeight(`${availableHeight}px`);
        }
    };
    return /*#__PURE__*/ $42omo.createElement("div", {
        "data-id": "content-tools-dropdown-menu-container",
        "data-test-id": "content-tools-dropdown-menu-container",
        "data-testid": "content-tools-dropdown-menu-container",
        ref: dropdownMenuContainerRef,
        className: (0, $gMc0m.default)([
            "_18u019bv _1ul91tcg",
            isExternalCollaborator && "_18u0idpf _1ul91tcg"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $52EPl.default), {
        testId: "content-tools-dropdown-menu",
        appearance: "tall",
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ $42omo.createElement((0, $1qfLF.default), {
                ...props,
                "data-id": "page-more-action-button",
                "data-test-id": "page-more-action-button",
                id: "tools-menu-trigger",
                label: intl.formatMessage($43c0d8bb08806c39$var$i18n.triggerLabel),
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))),
                ref: triggerRef,
                appearance: "subtle",
                isDisabled: isDisabled
            }),
        placement: "bottom-end",
        isOpen: isOpen,
        onOpenChange: handleOnOpenChange,
        shouldFlip: false,
        onPositioned: onPositioned,
        shouldRenderToParent: true
    }, /*#__PURE__*/ $42omo.createElement("div", {
        style: {
            maxHeight: drodownMenuMaxHeight
        }
    }, children || null)));
};
$43c0d8bb08806c39$var$ContentToolsButtonComponent.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).node,
    isDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    isExternalCollaborator: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    isOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    onOpenChange: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func,
    onPositioned: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func
};
const $43c0d8bb08806c39$export$f221d384e5b0f4c3 = /*#__PURE__*/ (0, $42omo.memo)($43c0d8bb08806c39$var$ContentToolsButtonComponent);
module.exports["ContentToolsButton"] = $43c0d8bb08806c39$export$f221d384e5b0f4c3;

});


//# sourceMappingURL=ForgeContentTools.76b164b0.js.map
